import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function BasePayForm({ entry, onSave, onCancel }) {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    annualBaseSalaryNOK: entry?.annualBaseSalaryNOK || '',
    effectiveDate: entry?.effectiveDate?.split('T')[0] || '',
    level: entry?.level || '',
    notes: entry?.notes || ''
  });

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      annualBaseSalaryNOK: parseFloat(form.annualBaseSalaryNOK) || 0,
      effectiveDate: form.effectiveDate,
      level: form.level ? parseInt(form.level) : null,
      notes: form.notes || null
    });
  };

  return (
    <form className="profile-form" onSubmit={handleSubmit}>
      <h3>{entry ? t('compensation.editBasePay') : t('compensation.addBasePay')}</h3>

      <div className="form-grid">
        <div className="form-group">
          <label>{t('compensation.baseSalary')} (NOK)</label>
          <input type="number" value={form.annualBaseSalaryNOK} onChange={e => handleChange('annualBaseSalaryNOK', e.target.value)}
            placeholder="e.g. 850000" step="1000" required />
        </div>

        <div className="form-group">
          <label>{t('compensation.effectiveDate')}</label>
          <input type="date" value={form.effectiveDate} onChange={e => handleChange('effectiveDate', e.target.value)} required />
        </div>

        <div className="form-group">
          <label>{t('compensation.level')} (59–70)</label>
          <input type="number" value={form.level} onChange={e => handleChange('level', e.target.value)}
            min="59" max="70" placeholder="e.g. 62" />
        </div>

        <div className="form-group full-width">
          <label>{t('compensation.notes')}</label>
          <textarea value={form.notes} onChange={e => handleChange('notes', e.target.value)}
            placeholder={t('compensation.basePayNotesPlaceholder')} rows="2" />
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="btn-primary">{t('common.save')}</button>
        <button type="button" className="btn-secondary" onClick={onCancel}>{t('common.cancel')}</button>
      </div>
    </form>
  );
}

export default BasePayForm;
